export default __webpack_public_path__ + "static/media/dolfijn1Klein.1694c9b9.jpg";